import img1 from "../../../images/Home/Img-1.png";
import img2 from "../../../images/Home/Img-2.png";
import img3 from "../../../images/Home/Img-3.png";
import img4 from "../../../images/Home/Img-4.png";

const images = [
  {
    id: 1,
    src: img1,
    alt: "Image1",
  },
  {
    id: 2,
    src: img2,
    alt: "Image2",
  },
  {
    id: 3,
    src: img3,
    alt: "Image3",
  },
  {
    id: 4,
    src: img4,
    alt: "Image4",
  }
];

export default images;
